import { IconButton } from '@mui/material'
import { CloseOMIcon } from '@omnea-app/icons'

type DialogCloseButtonProps = {
  onClick: () => void
  // Translated, since it's the button's only accessible name.
  ariaLabel: string
  disabled?: boolean
}

/**
 * The dismiss control for a Dialog. Render it as the last child of `DialogTitle`, which is a flex
 * row — the button takes the end of that row, so a title of any length reflows beside it rather
 * than needing the header to reserve space.
 */
export const DialogCloseButton = ({ onClick, ariaLabel, disabled }: DialogCloseButtonProps) => (
  <IconButton
    onClick={onClick}
    disabled={disabled}
    size="small"
    aria-label={ariaLabel}
    sx={{ ml: 'auto', flexShrink: 0, alignSelf: 'flex-start' }}
  >
    <CloseOMIcon />
  </IconButton>
)
